import api from '@/api/imt/subscriptions'
import baseModule from '@/store/shared/rest'

const defaultModule = baseModule('SUBSCRIPTION', 'subscriptions', api)

export default {
    ...defaultModule,
    namespaced: true,
}
